export default __webpack_public_path__ + "book_details-file_size.b921f503.png";